const settingsKeys = {
  userSettings: ["settings"],
};

export default settingsKeys;
